module.exports = __webpack_public_path__ + "img/hotel-deluxe.4e3b5536.png";